<template>
  <vx-list class="wrapper" enable :api="api" :params="params" :pageSize="25" @load="onLoad" @refresh="refresh" ref="listScroller">
    <div class="item-wrapper" v-for="(item, index) in list" :key="index">
      <div class="item flex-between van-hairline--bottom">
        <div class="left flex-between">
          <div class="avatar flex-center">
            {{ item.receiverName && item.receiverName.substr(-2) }}
          </div>
          <div class="name">
            {{ item.receiverName }}
          </div>
        </div>
        <div class="right flex-between">
          <van-icon
            class-prefix="vxs-icon"
            name="chat-check-fill"
            size="16"
            :color="!item.noticeOther ? 'var(--g6)' : 'var(--c2)'"
            @click="notice(item)"
          />
          <div class="split"></div>
          <van-icon
            @click="toggle(index)"
            :name="toggleList[index] ? 'arrow-up' : 'arrow-down'"
            size="16"
            color="var(--g6)"
          />
        </div>
      </div>
      <div class="parents van-hairline--bottom" v-if="toggleList[index]">
        <div
          v-for="item2 in toggleList[index]"
          :key="item2.parentId"
          class="flex-between parent-item"
          :class="{'no-bind': !item2.weChatBindingStatus}"
        >
          <div>{{ item2.relation }}：{{ item2.parentPhone }} {{!item2.weChatBindingStatus? ' 未绑定':''}}</div>
          <div class="flex-between" v-if="item2.weChatBindingStatus">
            <div
              class="status-circle"
              :class="[item2.confirmStatus == 2 ? 's-3' : item2.status == 2 ? 's-2' : 's-1']"
            ></div>
            {{ item2.confirmStatus == 2 ? item2.confirmStatusText : item2.statusText }}
          </div>
        </div>
        <div class="flex-between parent-item" v-if="item.noticeOther">
          {{item.noticeOtherUserName}}于 {{item.noticeOtherTime | formatDatetime('yyyy-MM-dd hh:mm')}} 标记
        </div>
      </div>
    </div>
    <van-button 
      type="primary" round 
      loading-text="发送中"
      :loading="sendLoading"
      @click="noticeParent"
      v-if="getDetail && status==1 && !alreadySend" class="warn-btn">{{
      `提醒${isNeedConfirm ? '未确认' : '未读'}家长`
    }}
    </van-button>
    <van-button 
      type="primary" round 
      disabled
      v-if="getDetail && status==1 && alreadySend" class="warn-btn">
      {{lastRemindTime | formatDatetime('yyyy-MM-dd')}}已提醒
    </van-button>

    <empty-page :show="list.length === 0" tips="还没有数据~" />
  </vx-list>
</template>

<script>
import emptyPage from '@teacher/components/empty-page.vue';
export default {
  name: 'notice-receive-list',
  props: ['status', 'isNeedConfirm' , 'uploadCount',],
  data() {
    return {
      list: [],
      api: this.$api.noticePage,
      params: {
        noticeTaskId: '',
      },
      toggleList: [],
      sendLoading: false,
      alreadySend: false,
      lastRemindTime: '',
      getDetail: false,
    };
  },
  computed: {},
  methods: {
    async noticeParent(){
      await vant.Dialog.confirm({
          title: '提示',
          message: `确认给所有${this.isNeedConfirm ? '未确认' : '未读'}家长发送提醒？`,
          confirmButtonText: '确认',
        });
      this.sendLoading = true;
      await this.$api.noticeAgain({
        noticeTaskId: this.params.noticeTaskId,
      });
      this.sendLoading = false;
      this.alreadySend = true;
      this.lastRemindTime = Date.now();
      this.$emit('refresh');
    },
    refresh(){
      this.$emit('refresh');
    },
    doRefresh(){
      this.$refs.listScroller.refresh();
    },
    onLoad(list, res) {
      vant.Toast.clear();
      this.list = list;
      this.uploadCount(res.page.totalCount);
      this.toggleList = [];
    },
    async toggle(index) {
      if (!this.toggleList[index]) {
        const noticeId = this.list[index].id;
        const studentId = this.list[index].receiverId;
        const res = await this.$api.studentParentNoticeReadPage({
          noticeId,
          studentId,
        });
        this.$set(this.toggleList, index, res.data);
      } else {
        this.$set(this.toggleList, index, false);
      }
    },
    async notice(item){
      if (item.noticeOther == 1){
        return;
      }
      await this.$dialog.confirm({
        title: '提示',
        message: `将“${item.receiverName}”标记为“已通过其他方式通知”（表示已通过电话、微信、直接沟通等其他方式传达）`,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })

      const res1 = await this.$api.noticeOther({
        noticeId:item.id
      })
      item.noticeOther = 1;
      item.noticeOtherUserName = res1.data.noticeOtherUserName;
      item.noticeOtherTime = res1.data.noticeOtherTime;
    }
  },
  created() {
    this.params.noticeTaskId = this.$route.params.id;
    if (this.isNeedConfirm) {
      this.params.confirmStatus = [this.status];
    } else {
      this.params.status = [this.status];
    }
  },
  beforeDestroy() {},
  components: { emptyPage },
};
</script>

<style lang="scss" scoped>
.wrapper {
  height: 100%;
  background: var(--white);
  .item-wrapper {
    .item {
      height: calc(var(--gap) * 55);
      padding: 0 calc(var(--gap) * 16);
      .left {
        .avatar {
          width: calc(var(--w) * 30);
          height: calc(var(--w) * 30);
          border-radius: 50%;
          margin-right: calc(var(--gap) * 7);
          background: var(--g6);
          color: var(--white);
          background-color: var(--c1);
        }
        .name {
          color: var(--g8);
          font-size: var(--fs-lg);
          line-height: var(--lh-lg);
          font-weight: var(--bold);
        }
      }
      .right {
        .split {
          width: 0;
          height: calc(var(--w) * 16);
          border-left: 1px solid var(--g3);
          margin: 0 calc(var(--gap) * 16);
        }
      }
    }
    .parents {
      padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
      .parent-item {
        font-size: var(--fs-md);
        line-height: var(--lh-md);
        color: var(--g6);
        &:not(:first-child) {
          margin-top: calc(var(--gap) * 8);
        }
        &.no-bind{
          color:var(--g5);
        }
        .status-circle {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          margin-right: 8px;
          &.s-1 {
            background: var(--g5);
          }
          &.s-2 {
            background: var(--c4);
          }
          &.s-3 {
            background: var(--c2);
          }
        }
      }
    }
  }
  .warn-btn {
    position:fixed;
    bottom: 16px;
    left: calc(50% - 90px);
    width: 180px;
  }
}
</style>
